import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getOrderDetails } from "store/orderSlice";
import ItemsTable from "./components/ItemsTable";
import BasicInfo from "./components/BasicInfo";
import { resetOrderDetails } from "store/orderSlice";
import OrderTracking from "./components/OrderTracking";
import { getOrderNotes } from "store/noteSlice";

export default function OrderDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetOrderDetails());
  }, [dispatch]);

  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const refreshList = () => {
    setRefreshTrigger((prev) => !prev);
  };
  useEffect(() => {
    dispatch(getOrderDetails({ id }));
    dispatch(
      getOrderNotes({
        relatedId: id,
        relatedModel: "orders",
      })
    );
  }, [dispatch, id, refreshTrigger]);

  return (
    <div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <BasicInfo refreshList={refreshList} />
        <OrderTracking />
        <ItemsTable refreshList={refreshList} />
      </div>
    </div>
  );
}
